const person = [
  {
    id: 1,
    prefix: "ผศ.ดร.น.สพ.",
    frist_name: "อติกันต์",
    last_name: "ทองทาบ",
    positionID: 1,
    position: "ผู้อำนวยการ",
    position_short: "ผอ.",
    img: "https://vmcmu.vet.cmu.ac.th/assets/images/management_team/%E0%B8%AD.%E0%B8%99%E0%B8%B1%E0%B8%97.01.png",
    email: "attvet62@hotmail.com",
    phone: "053-948114",
    company: "",
  },
  // {
  //   id: 2,
  //   prefix: "...",
  //   frist_name: "...",
  //   last_name: "...",
  //   positionID: 2,
  //   position: "รองผู้อำนวยการ",
  //   position_short: "รอง.ผอ.",
  //   img: "",
  //   email: "...",
  //   phone: "...",
  //   company: "",
  // },
  // {
  //   id: 3,
  //   prefix: "...",
  //   frist_name: "...",
  //   last_name: "...",
  //   positionID: 2,
  //   position: "รองผู้อำนวยการ",
  //   position_short: "รอง.ผอ.",
  //   img: "",
  //   email: "...",
  //   phone: "...",
  //   company: "",
  // },
  // {
  //   id: 4,
  //   prefix: "...",
  //   frist_name: "...",
  //   last_name: "...",
  //   positionID: 2,
  //   position: "รองผู้อำนวยการ",
  //   position_short: "รอง.ผอ.",
  //   img: "",
  //   email: "...",
  //   phone: "...",
  //   company: "",
  // },
];

export { person };
